import { render } from "./CartShop.vue?vue&type=template&id=3c456ae6"
import script from "./CartShop.vue?vue&type=script&lang=js"
export * from "./CartShop.vue?vue&type=script&lang=js"

import "./CartShop.vue?vue&type=style&index=0&id=3c456ae6&lang=css"

import exportComponent from "/home/kira/codemark/zonadigital/frond/deploy/zona-digital-ecommerce-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__